<template>
  <div class="edit-box">
    <div class="frm-area">
      <div class="title">提现交易密码</div>
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <div class="frm-item" v-if="safeUsrInfo.has_pay_password == 1">
            <div class="frm-label">提现交易密码</div>
            <van-field
              v-model="frm.old_pay_password"
              placeholder="请填写提现交易密码"
              :rules="[{ required: true, message: '请填写提现交易密码' }]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">
              {{
                safeUsrInfo.has_pay_password != 1
                  ? '提现交易密码'
                  : '提现交易新密码'
              }}
            </div>
            <van-field
              v-model="frm.new_pay_password"
              placeholder="请填写提现交易密码"
              :rules="[
                {
                  required: true,
                  message:
                    safeUsrInfo.has_pay_password != 1
                      ? '请填写提现交易密码'
                      : '请填写提现交易新密码'
                }
              ]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">确认密码</div>
            <van-field
              v-model="frm.new_pay_password_confirm"
              placeholder="再次输入新交易密码"
              :rules="[{ validator: validator, message: '再次输入新交易密码' }]"
            />
          </div>
          <div class="btn-box">
            <van-button
              native-type="submit"
              :loading="posting"
              loading-text="提交中..."
              style="background-color: #141423; color: #fff; border-radius: 8px"
              >设置</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditPayPasswordView',
  props: ['usrInfo'],
  computed: {
    safeUsrInfo () {
      return this.usrInfo || null
    }
  },
  data () {
    return {
      posting: false,
      frm: {
        old_pay_password: null,
        new_pay_password: null,
        new_pay_password_confirm: null
      }
    }
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    validator(val){
        return this.frm.new_pay_password == val
   
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'setpaypwd',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false
          this.frm = {
            old_pay_password: null,
            new_pay_password: null,
            new_pay_password_confirm: null
          }
          this.$emit('refresh-usrinfo')
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
